<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconClock_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m3.719 9.042a.75.75 0 0 1-1.018.296L7.639 8.657A.75.75 0 0 1 7.25 8V3a.75.75 0 0 1 1.5 0v4.556l2.672 1.468a.75.75 0 0 1 .297 1.018"
    />
</svg>
